<table [formGroup]="formArray.parent">
  <thead>
    <tr>
      <th class="text-center">Código</th>
      <th class="title">Entregável</th>
      <th class="">Prazo planejado</th>
      <th class="">Previsão atual</th>
      <th class="" colspan="2">Status</th>
      <th class="">Atualização</th>
      <th class="">PC</th>
      <th class=""></th>
    </tr>
  </thead>
  <tbody formArrayName="acPrtIssuesCommon">
    <ng-container *ngFor="let com of formArray?.controls; let i_p_p = index"  [formGroupName]="i_p_p">
      <tr *ngIf="currentItem[i_p_p] as variable" class="tr-{{i_p_p % 2}}">
        <td>{{parentId}}.{{variable.code}}</td>
        <td>{{variable.description}}</td>
        <td>{{variable.dt_conclusion | date: 'dd/MM/YYYY'}}</td>
        <td>{{variable.dt_foreseen | date: 'dd/MM/YYYY'}}</td>
        <td>{{variable.status_name ?? 'NI'}}</td>
        <td>
          <div class="dot dot-issue-{{variable?.status1 ?? 0}}"></div>
        </td>
        <td>{{variable.str_nome}}
          <br/>
          {{variable.ctr_dth_atu | date: 'dd/MM/YYYY'}}
        </td>
        <td class="text-danger">{{variable.total_pc}}</td>
        <td>
          <span class="icon-table icon-button" *ngIf="variable?.analysis_description" (click)="variable['show_description'] = variable['show_description'] != null? !variable['show_description']:true">
            <img src="assets/images/svgs/lupa{{variable?.show_description?'-menos':''}}.svg" alt="Consultar" tooltip="Consultar" placement="bottom">
          </span>
        </td>
      </tr>
      <tr *ngIf="currentItem[i_p_p]['show_description'] == true">
        <td colspan="12"  class="break-word td-description">{{currentItem[i_p_p]['analysis_description'] }}</td>
      </tr>
    </ng-container>
  </tbody>
</table>